// 服务请求构建器
// 根据不同的 provider 类型构建对应的请求格式

export interface BuildRequestOptions {
  provider: string
  serviceId: string
  userParameters: Record<string, any>
}

export interface RequestInfo {
  url: string
  method: string
  headers: Record<string, string>
  body: string
}

/**
 * 根据 provider 类型构建请求信息
 */
export function buildServiceRequest(
  options: BuildRequestOptions,
  apiKey: string
): RequestInfo {
  const { provider, serviceId, userParameters } = options
  const baseUrl = import.meta.env.VITE_WORKER_URL || 'https://proxy.apimakt.com'

  // 默认请求信息
  const requestInfo: RequestInfo = {
    url: `${baseUrl}/api/v1/proxy/${serviceId}`,
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${apiKey}`,
      'Content-Type': 'application/json',
    },
    body: '',
  }

  // 根据 provider 类型构建请求体
  switch (provider) {
    case 'coze-workflow':
      requestInfo.body = JSON.stringify({
        parameters: {
          parameters: userParameters
        },
        operation_type: 'execute'
      }, null, 2)
      break

    case 'coze-agent':
      requestInfo.body = JSON.stringify({
        parameters: {
          ...userParameters
        },
        operation_type: 'chat'
      }, null, 2)
      break

    case 'dify-workflow':
    case 'n8n-workflow':
      requestInfo.body = JSON.stringify({
        parameters: userParameters,
        operation_type: 'execute'
      }, null, 2)
      break

    case 'api-service':
    default:
      // 通用 API 服务，直接传递用户参数
      requestInfo.body = JSON.stringify(userParameters, null, 2)
      break
  }

  return requestInfo
}

/**
 * 格式化请求头为显示字符串
 */
export function formatHeaders(headers: Record<string, string>, maskApiKey = true): string {
  const lines: string[] = []
  for (const [key, value] of Object.entries(headers)) {
    if (key === 'Authorization' && maskApiKey) {
      const parts = value.split(' ')
      if (parts.length === 2) {
        const maskedKey = parts[1].substring(0, 12) + '...'
        lines.push(`${key}: ${parts[0]} ${maskedKey}`)
      } else {
        lines.push(`${key}: ${value}`)
      }
    } else {
      lines.push(`${key}: ${value}`)
    }
  }
  return lines.join('\n')
}
